export class AgencyGroupUserRoles {
  static readonly SuperUser = 'SuperUser';
  static readonly Marketing = 'Marketing';
  static readonly Finance = 'Finance';
  static readonly Agent = 'Agent';
  static readonly CrossAccountMarketingFinanceUser = 'CrossAccountMarketingFinanceUser';
  static readonly SmartCommissionAdministrator = 'SmartCommissionAdministrator';
}
